import type { LogProvider } from '@vista/diagnostics'
import { VistaDiagnosticsLog } from '@vista/diagnostics'
import { logger } from '@vista-digital/occ-domain'
import { getLogger, type LazyTagLogger } from '../logger.service'
import type { LoggerConfiguration } from '../logger.types'
import { ConsoleLogger } from './console.logger'
import { Site24x7RumLogger } from './site24x7rum.logger'

export class LoggerProvider extends VistaDiagnosticsLog {
    private readonly console = 'Console'
    private readonly site24x7 = 'Site24x7'

    public constructor(configuration: LoggerConfiguration) {
        super()

        // Hacky method to remove default console log provider
        this['_providers'] = {}

        const config = {
            config: configuration,
        }

        this.registerProvider(this.console, new ConsoleLogger(), config)
        this.registerProvider(this.site24x7, new Site24x7RumLogger(), config)

        this.includeGlobalErrors(true)

        this.proxyOccLogs()
    }

    private proxyOccLogs() {
        // // Remove default OCC console logger
        // // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- ok
        // vistaDiagnosticLogInstance['_providers']?.['console']

        // // Proxy OCC logs into our custom logger flow
        // vistaDiagnosticLogInstance.registerProvider('OccProxyLogger', new OccProxyLogger(), {})

        logger.registerProvider('console', new NoopLogger(), {})
        logger.registerProvider('OccProxyLogger', new OccProxyLogger(), {})
    }
}

class NoopLogger implements LogProvider {
    public log() {
        // Noop
    }
}

class OccProxyLogger implements LogProvider {
    private _logger: LazyTagLogger

    public constructor() {
        this._logger = getLogger('OCC')
    }

    public log(configuration, debugByTagPool, severity, method, message, tags, args) {
        if (tags) {
            const tagsArray = Array.isArray(tags) ? tags : [tags]
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- safe enough
            getLogger(['OCC', ...tagsArray]).value[method](message, ...args)
            return
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- safe enough
        this._logger.value[method](message, ...args)
    }
}
